import { render, staticRenderFns } from "./OrganisasiPengusahaProvinsi.vue?vue&type=template&id=9957a91a"
import script from "./OrganisasiPengusahaProvinsi.vue?vue&type=script&lang=js"
export * from "./OrganisasiPengusahaProvinsi.vue?vue&type=script&lang=js"
import style0 from "./OrganisasiPengusahaProvinsi.vue?vue&type=style&index=0&id=9957a91a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports